import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import 'dotdotdot-js'
@Component({
  selector: 'app-promotion-detail',
  templateUrl: './promotion-detail.component.html',
  styleUrls: ['./promotion-detail.component.scss']
})
export class PromotionDetailComponent implements OnInit, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  constructor(private route: ActivatedRoute, private _mainService: MainService,
    private _sanitizer: DomSanitizer) { }
  language = JSON.parse(localStorage.getItem('language'))

  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';


  promotion: any;
  showpromotion: any;
  detail: any;
  file_pdf: string;
  promotionTitle: string;
  promotionType: string;
  promotionDate: string;
  pdfUrl_path: any;
  pdfUrl: any;

  id: any;
  private player;
  private ytEvent;

  filesize: any;

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.promotion = this.route.params.subscribe(params => {
      this._mainService.getpromotionByID(params['id']).subscribe(response => {
        //case news type is text
        if (this.flag == 'th') {
        if (response[0].promotion_type === 'text') {
          this.file_pdf = 'no';
          response[0].detail = this.htmlTransforms(response[0].detail);
          this.detail = this.htmlTransforms(response[0].detail);

          this.showpromotion = response;
          this.promotionTitle = response[0].title;
          this.promotionType = response[0].promotion_type;
          this.promotionDate = this._mainService.date_thai(response[0].publicDate);

        } else if (response[0].promotion_type === 'image') {
          this.file_pdf = 'no';
          this.showpromotion = response;
          this.detail = response[0].detail;
          this.promotionTitle = response[0].title;
          this.promotionType = response[0].promotion_type;
          this.promotionDate = this._mainService.date_thai(response[0].publicDate);

        } else if (response[0].promotion_type === 'pdf') {
          this.file_pdf = 'yes';
          this.pdfUrl_path = response[0].detail;
          this.showpromotion = response;
          this.pdfUrl = this.urlTransform(response[0].detail);
          this.promotionTitle = response[0].title;
          this.promotionType = response[0].promotion_type;
          this.filesize = response[0].filesize
          this.promotionDate = this._mainService.date_thai(response[0].publicDate);

        }
        else if (response[0].promotion_type === 'vdo') {
          this.file_pdf = 'no';
          this.showpromotion = response;
          this.detail = response[0].detail;
          this.id = response[0].detail;
          this.promotionTitle = response[0].title;
          this.promotionType = response[0].promotion_type;
          this.promotionDate = this._mainService.date_thai(response[0].publicDate);

        }
      } else {
          if (response[0].promotion_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail_en = this.htmlTransforms(response[0].detail_en);
            this.detail = this.htmlTransforms(response[0].detail_en);
  
            this.showpromotion = response;
            this.promotionTitle = response[0].title_en;
            this.promotionType = response[0].promotion_type;
            this.promotionDate = response[0].publicDate;
  
          } else if (response[0].promotion_type === 'image') {
            this.file_pdf = 'no';
            this.showpromotion = response;
            this.detail = response[0].detail_en;
            this.promotionTitle = response[0].title_en;
            this.promotionType = response[0].promotion_type;
            this.promotionDate = response[0].publicDate;
  
          } else if (response[0].promotion_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail_en;
            this.showpromotion = response;
            this.pdfUrl = this.urlTransform(response[0].detail_en);
            this.promotionTitle = response[0].title_en;
            this.promotionType = response[0].promotion_type;
            this.filesize = response[0].filesize
            this.promotionDate = response[0].publicDate;
  
          }
          else if (response[0].promotion_type === 'vdo') {
            this.file_pdf = 'no';
            this.showpromotion = response;
            this.detail = response[0].detail_en;
            this.id = response[0].detail_en;
            this.promotionTitle = response[0].title_en;
            this.promotionType = response[0].promotion_type;
            this.promotionDate = response[0].publicDate;
  
          }
        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,
        })
      })
    })
  }

  ngOnDestroy() {
    this.promotion.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }

  onStateChange(event) {
    this.ytEvent = event.data;
  }
  savePlayer(player) {
    this.player = player;
  }


}
